import { Loader } from '@ytl/common-web';
import { useOpenAm } from '../contexts/openAmContext';
import { OpenAmAuthError } from '../shared/@types/OpenAmInitialData';
import { LoginView } from '../shared/@types/OpenAmStage';
import { AccountLockedError } from './AccountLockedError';
import { ErrorView } from './ErrorView';
import { LoginHero } from './LoginHero';
import { LoginYoloOtpState } from './LoginYoloOtpState';
import { MockTestLoginStage } from './MockTestLoginStage';
import { MSISDNVerificatorCodeStage } from './MSISDNVerificatorCodeStage';
import { RealmSwitchView } from './RealmSwitchView';
import { SmsCodeStage } from './SMSCodeStage';
import { SmsNumberSelectorStage } from './SMSNumberSelectorStage';
import { SmsPhoneNumberStage } from './SMSPhoneNumberStage';
import { UserNamePasswordStage } from './UserNamePasswordStage';

export const LoginWithEmailAndSms = () => {
  const { stage, error } = useOpenAm();
  const view = stage.view;

  const showAuthorizationUI =
    !error ||
    error === OpenAmAuthError.AccountIsLocked ||
    error === OpenAmAuthError.InvalidTypeB2B ||
    error === OpenAmAuthError.InvalidTypeB2C ||
    error === OpenAmAuthError.EmptyPhoneNumberList;
  const isRealmSwitch = error === OpenAmAuthError.RealmSwitch;
  console.log('view, ', view);

  return (
    <>
      <div className="login-page__wrapper">
        <div className="login-page__container">
          <div className={`login-page__container__box ${error ? 'login-page__container__box--error-view' : ''}`}>
            {showAuthorizationUI && (
              <>
                {view === LoginView.Loader && (
                  <div className="login-page__container__page-loader">
                    <Loader isLoading={true} />
                  </div>
                )}
                {view === LoginView.LoginForm && <UserNamePasswordStage />}
                {view === LoginView.SMSPhoneNumber && <SmsPhoneNumberStage />}
                {(view === LoginView.SMSCode || view === LoginView.SMSCodeChange2FA) && <SmsCodeStage />}
                {view === LoginView.MSISDNCode && <MSISDNVerificatorCodeStage />}
                {view === LoginView.SMSNumberSelector && <SmsNumberSelectorStage />}
                {view === LoginView.YoloOtpStage && <LoginYoloOtpState />}
                {view === LoginView.TestLogin && <MockTestLoginStage />}
                {(error === OpenAmAuthError.AccountIsLocked ||
                  error === OpenAmAuthError.InvalidTypeB2B ||
                  error === OpenAmAuthError.InvalidTypeB2C ||
                  error === OpenAmAuthError.EmptyPhoneNumberList) && <AccountLockedError />}
              </>
            )}
            {!showAuthorizationUI && !isRealmSwitch && <ErrorView />}
            {!showAuthorizationUI && isRealmSwitch && <RealmSwitchView />}
          </div>
        </div>

        <LoginHero />
      </div>
    </>
  );
};
